/**
 * Converts API live-status identifiers into readable labels without changing
 * the raw values used for grouping, filters, or test identifiers.
 */
export function formatLiveStatus (status: string): string {
  return status
    .split('_')
    .filter(Boolean)
    .map((word) => {
      const normalized = word.toLowerCase();
      return normalized.charAt(0).toUpperCase() + normalized.slice(1);
    })
    .join(' ');
}
